let SigninMode = {
    CHECKOUT: 'CHECKOUT'
};

export default SigninMode;